module.exports = __webpack_public_path__ + "img/dianliu-1.png";